import { Fragment, useEffect, useRef } from "react";

const ManageChatHistoryModal = ({ close = () => {}, getResponse, data }) => {
  const messagesEndRef = useRef(null);
  console.log({ data });

  // Sample data matching your table structure
  const selectedContact = {
    id: 1,
    name: data?.name,
    initials: data?.name.charAt(0),
    email: data?.email,
    avatar: null,
    messages: [
      {
        id: 1,
        type: data?.type,
        content: data?.comment,
        timestamp: data?.createdAt,
        userName: "User",
        read: true,
      },
      ...data?.reply?.map((item, index) => ({
        id: index + 2,
        type: item?.type,
        content: item?.message,
        timestamp: item?.createdAt,
        adminName: "Admin",
        read: true,
      })),
    ],
    // [
    //   {
    //     id: 1,
    //     type: "user",
    //     content:
    //       "How you doing? I wanted to reach out and see how things are going.",
    //     timestamp: "2024-06-08T09:20:00Z",
    //     read: true,
    //   },
    //   {
    //     id: 2,
    //     type: "admin",
    //     content:
    //       "Hi Samuel! Thanks for reaching out. We're doing well, thank you for asking. How can we assist you today?",
    //     timestamp: "2024-06-08T09:45:00Z",
    //     read: true,
    //     adminName: "Support Team",
    //   },
    //   {
    //     id: 3,
    //     type: "user",
    //     content:
    //       "Great to hear! I was wondering about your services and pricing.",
    //     timestamp: "2024-06-08T10:00:00Z",
    //     read: false,
    //   },
    // ],
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (selectedContact) {
      scrollToBottom();
    }
  }, [selectedContact?.messages]);

  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleDateString();
  };

  const getInitialsColor = (initials) => {
    const colors = [
      "bg-red-500",
      "bg-blue-500",
      "bg-green-500",
      "bg-yellow-500",
      "bg-purple-500",
      "bg-pink-500",
      "bg-indigo-500",
      "bg-teal-500",
    ];
    const index = initials?.charCodeAt(0) % colors.length;
    return colors[index];
  };

  return (
    <Fragment>
      <div className="flex items-center justify-between p-6 border-b border-gray-200">
        <div className="flex items-center gap-3">
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold ${getInitialsColor(
              selectedContact.initials
            )}`}
          >
            {selectedContact.initials}
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              {selectedContact.name}
            </h3>
            <p className="text-sm text-gray-500">{selectedContact.email}</p>
          </div>
        </div>
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto max-h-96 p-4 space-y-4">
        {selectedContact?.messages.map((message) => (
          <div
            key={message.id}
            className={`flex ${
              message.type === "admin" ? "justify-end" : "justify-start"
            }`}
          >
            <div
              className={`max-w-xs lg:max-w-md ${
                message.type === "admin" ? "order-2" : "order-1"
              }`}
            >
              <div
                className={`px-4 py-2 rounded-lg ${
                  message.type === "admin"
                    ? "bg-blue-500 text-white"
                    : "bg-gray-200 text-gray-900"
                }`}
              >
                {message.type === "admin" && message.adminName ? (
                  <div className="text-xs opacity-75 mb-1">
                    {message.adminName}
                  </div>
                ) : (
                  <div className="text-xs opacity-75 mb-1">
                    {message.userName}
                  </div>
                )}
                <p className="text-sm">{message.content}</p>
                <div
                  className={`flex items-center justify-between mt-1 text-xs ${
                    message.type === "admin" ? "text-blue-100" : "text-gray-500"
                  }`}
                >
                  <span className="mr-4">{formatTime(message.timestamp)}</span>
                  {message.type === "admin" && (
                    <i
                      size={12}
                      className={
                        message.read
                          ? "text-green-300 fas fa-check-circle"
                          : "text-gray-300 fas fa-check-circle"
                      }
                    />
                  )}
                </div>
              </div>
              <div className="text-xs text-gray-500 mt-1 px-2">
                {formatDate(message.timestamp)}
              </div>
            </div>
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-semibold ${
                message.type === "admin"
                  ? "bg-blue-500 order-1 mr-2"
                  : `${getInitialsColor(selectedContact.initials)} order-2 ml-2`
              }`}
            >
              {message.type === "admin" ? (
                <i className="fas fa-user" size={16} />
              ) : (
                selectedContact.initials
              )}
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
    </Fragment>
  );
};

export default ManageChatHistoryModal;
